import { BlogSection } from "@/2-sections/bands/BlogSection";
import { CaseShowcase } from "@/2-sections/bands/CaseShowcase";
import { CompaniesBento } from "@/2-sections/bento/CompaniesBento";
import { DualCTA } from "@/2-sections/page/DualCTA";
import { HeroTurbine } from "@/2-sections/page/HeroTurbine";
import Partners from "@/2-sections/Partners";
import { useT } from "@/3-features/i18n/useT";
import { PATHS } from "@/3-features/navigation/routes";
import { solutionPath,VALUE_PROPS } from "@/3-features/solutions/valueProps";
import { StatsCounter } from "@/4-components/composites/Counter/StatsCounter";
import { DecContract } from "@/4-components/primitives/DecContract";
import { CASES } from "@/5-shared/constants/content/companiesOverview";
import { tObj } from "@/5-shared/utils/i18n";

type CaseCopy = { title: string; body: string; link: string };

export function CompaniesOverview() {
  const { t } = useT(["companies-home", "common"]);
  /* CASES (code) owns the set + order; each case's copy is one typed record keyed
     by its vp slug, so there is no array index-zip and the JSON stays a flat
     per-slug lookup (regular {title,body,link}, resolved in a single tObj). */
  const caseItems = CASES.map(({ vp, ...data }) => {
    const prop = VALUE_PROPS.find((p) => p.slug === vp)!;
    const { link, ...copy } = tObj<CaseCopy>(t, `cases.items.${vp}`);
    return { ...data, ...copy, solution: { label: link, to: solutionPath(prop) } };
  });
  return (
    <div>
      <HeroTurbine
        eyebrow={t("hero.eyebrow")}
        title={
          <>
            {t("hero.title")}
            <br />
            <span className="text-dec-green">{t("hero.highlight")}</span>
          </>
        }
        subtitle={t("hero.subtitle")}
        cta={{ label: t("common:cta.contactShort"), to: PATHS.contact }}
        card={{
          icon: <DecContract className="h-11 w-auto text-dec-green" />,
          head: t("overview.head"),
          sub: tObj<string[]>(t, "overview.sub"),
        }}
        cowLine={t("overview.cowLine")}
      />
      <Partners />
      <CompaniesBento />
      <StatsCounter stats={tObj<Array<{ target: string | number; label: string; prefix?: string; suffix?: string }>>(t, "common:stats")} />
      <CaseShowcase eyebrow={t("cases.eyebrow")} heading={t("cases.heading")} sub={t("cases.sub")} items={caseItems} />
      <BlogSection />
      <DualCTA title={t("overview.ctaTitle")} />
    </div>
  );
}
